/* js/searchBox.js */


jQuery( document ).ready(function( $ ) {
    $('.js-searchBox-trigger').click(function (e) {
        e.preventDefault();
        $('body').toggleClass('searchBox-open');
    });


    /*$(document).mouseup(function (e)
    {
        var container = $('.searchBox');

        if (!container.is(e.target) // if the target of the click isn't the container...
            && container.has(e.target).length === 0) // ... nor a descendant of the container
        {
            $('body').removeClass('searchBox-open');
        }
    });*/


});